import { Grid } from '@material-ui/core';
import teslaInside from './assets/images/happy.jpg'
import Popover from './components/Popover';
import { SocialIcon } from 'react-social-icons';
import ParticleAnim from './components/ParticleAnim';
import Initialization from './components/Initialization';
function App() {
  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          backgroundImage: `linear-gradient(
        rgba(0, 60, 255, 0.35), 
        rgba(250, 250, 250, 0.35)
      ),url(${teslaInside})`,
          backgroundSize: "cover",
          maxWidth: "100%",
          height: "100vh",
        }}
      >
        <ParticleAnim />
        <Grid container style={{ position: "relative", zIndex: 2 }}>
          <Grid container>
            <Grid item xs={6} container justify="center">
              <h1
                style={{
                  color: "yellowgreen",
                  padding: "1rem",
                  textShadow: "3px 3px 3px black",
                }}
              >
                Just Smile
              </h1>
            </Grid>
            <Grid item xs={6} container justify="center" alignContent="center">
              <Popover />
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            justify="center"
            alignItems="center"
            container
            style={{ height: "83vh" }}
          >
            <h1
              style={{
                textShadow: "3px 3px 3px black",
                color: "yellow",
                textAlign: "center",
                margin: "3rem",
              }}
            >
              Welcome to Just Smile Coin
              <br />
              <span style={{ color: "#01a3a4", fontSize: "25px" }}>
                Just Smile is a community driven and Fair launch RFI project
                <br />
                build on Binance Smart Chain #BSC.
              </span>
            </h1>
          </Grid>
          <Grid container item>
            <Grid item style={{ marginLeft: "2rem" }}>
              <SocialIcon url="https://twitter.com/JustSmileBSC" />
            </Grid>
            <Grid item style={{ marginLeft: "2rem" }}>
              <SocialIcon url="https://www.reddit.com/search/?q=JustSmile%20(%24JustSmile)&sort=relevance&t=hour&type=link" />
            </Grid>
            <Grid item style={{ marginLeft: "2rem" }}>
              <SocialIcon url="https://t.me/JustSmileBSC" />
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <h1
              style={{ textAlign: "center", marginTop: "2rem", color: "white" }}
            >
              Features
            </h1>
          </Grid>
          <Initialization />
        </Grid>
      </div>
    </div>
  );
}

export default App;
